
<template>
    <b-container class="reporting-info-container">
        <b-breadcrumb class="breadCrumb">
            <router-link :to="`/admin/reporting`"> Reporting Dashboard </router-link>
            <b-breadcrumb-item active> /{{ clientName }} </b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card px-4">

            <!-- Client Details Table -->
            <div class="overflow-auto w-100 d-none d-md-block b2b-table tableContainer">
                <b-table stacked :items="clientRows" striped>
                    <template #cell(client_logo)="row">
                        <div class="d-flex justify-content-start">
                            <div class="logo-slot">
                                <img class="client-logo" :src="row.item.client_logo" alt="Logo">
                            </div>
                        </div>
                    </template>
                    <template #cell(reports)="row">
                        <div class="d-flex justify-content-start">
                            <div class="td">
                                <li v-for="report in row.item.reports">
                                    <router-link v-if="reportsConfig[report]" :to="reportsConfig[report].link + tenantId">
                                        {{ reportsConfig[report].label }}
                                    </router-link>
                                </li>
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>


        <b-row>

            <!-- Date Pickers -->
            <b-col cols=12 md=auto class="mt-3">
                <div class="d-flex flex-row align-items-center">
                    <label class="filter-label" :for="'fromDate'">From</label>
                    <div class="ml-2 w-100 px-4 px-md-1">
                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                            class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
                        </b-form-datepicker>
                    </div>
                </div>
            </b-col>

            <b-col cols=12 md=auto class="mt-3 date-picker-div">
                <div class="d-flex flex-row align-items-center">
                    <label class="filter-label" :for="'toDate'">To</label>
                    <div class="ml-2 w-100 px-4 px-md-1">
                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                            class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
                        </b-form-datepicker>
                    </div>
                </div>
            </b-col>

            <!-- Date Buttons -->
            <b-col md=auto class="date-div">
                <b-button class="date-button" variant="primary" @click="dateFilter">Apply</b-button>
            </b-col>
            <b-col md=auto class="date-div">
                <b-button class="clear-button" variant="secondary" @click="clearDateFilter">Clear</b-button>
            </b-col>


        </b-row>

        <div class="card px-4">

            <div class="card-div">
                <div class="min-workout">
                    <div class="row">
                        <img src="../assets/images/settings icon.png" alt="settings-icon" class="settings-icon-img"
                            width="30px" style="float: right;" @click="criteria()" v-b-modal.criteria-modal />

                        <b-modal ref='criteria-modal' id="criteria-modal" class="text-light"
                            dialog-class="b2b-access-code-dialog border-0" content-class="bg-dark border-0"
                            header-class="text-light" body-class="p-0" :hide-footer="false" :title="'Configuration'">
                            <b-row>
                                <b-col>
                                    <h5>Active Users Criteria</h5>
                                </b-col>
                            </b-row>
                            <b-row class="criteria-div">
                                <b-col md=auto class="criteria-label-col"><label class="criteria-label">Minimum
                                        Workouts Completed</label>
                                </b-col>
                                <b-col cols=2 class="min-workout-search-bar">
                                    <b-form-input v-model="minWorkouts" placeholder="Minimum workouts"></b-form-input>
                                </b-col>
                            </b-row>

                            <div class="criteria-div row">

                                <b-col md=auto class="criteria-label-col"><label class="criteria-label">Minimum
                                        Duration (in minutes)</label></b-col>
                                <b-col cols=2 class="min-workout-search-bar">
                                    <b-form-input v-model="minWorkoutDuration"
                                        placeholder="Minimum duration(mins)"></b-form-input>
                                </b-col>

                            </div>

                            <hr>

                            <b-row>
                                <b-col>
                                    <h5>Workouts Completed Criteria</h5>
                                </b-col>
                            </b-row>
                            <b-row class="criteria-div">
                                <b-col md=auto class="criteria-label-col"><label class="criteria-label">Percentage of
                                        Workout Completed</label>
                                </b-col>
                                <b-col cols=2 class="percentage-workout-search-bar">
                                    <b-form-input v-model="percentageOfWorkout"
                                        placeholder="Percentage of workout completed"></b-form-input>
                                </b-col>
                            </b-row>

                            <div slot="modal-footer">
                                <b-row>
                                    <b-col>
                                        <b-button class=" float-right criteria-button" variant="primary"
                                            @click="criteriaFilter">
                                            Apply
                                        </b-button>
                                    </b-col>
                                    <b-col>
                                        <b-button class="float-right criteria-button" variant="secondary"
                                            @click="clearCriteriaFilter">
                                            Clear
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-modal>
                    </div>
                </div>
                <div class="row">

                    <div class="col-6 col-md-3 mb-3">
                        <div class="card border-card">
                            <div class="card-body">
                                <div class="info-card-title">
                                    New User Sign Ups
                                </div>
                                <div class="value" v-if="!isLoading">
                                    {{ newUsers }}
                                </div>
                                <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 col-md-3 mb-3">
                        <div class="card border-card">
                            <div class="card-body">
                                <div class="info-card-title">
                                    Active Users
                                    <div class="i-border text-dark notranslate" id="active-users">i</div>
                                </div>

                                <b-tooltip custom-class="custom-tooltip" target="active-users" title="Tooltip title">
                                    Minimum {{ minWorkouts }} workout(s) completed.
                                </b-tooltip>

                                <div class="value" v-if="!isLoading">
                                    {{ activeUsers }}
                                </div>
                                <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 col-md-3 mb-3">
                        <div class="card border-card">
                            <div class="card-body">
                                <div class="info-card-title">
                                    Workouts Clicked
                                </div>
                                <div class="value" v-if="!isLoading">
                                    {{ workoutsClicked }}
                                </div>
                                <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 col-md-3 mb-3">
                        <div class="card border-card">
                            <div class="card-body">
                                <div class="info-card-title">
                                    Workouts Duration
                                </div>
                                <div class="value" v-if="!isLoading">
                                    {{ workoutsDuration }}
                                </div>
                                <div class="spinner-border text-light spinner-border-sm mt-2" role="status" v-else>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="buttons-container">
                <b-button :pressed="showUser" class="buttons" variant="primary" @click="toggleUser">Users</b-button>
                <b-button :pressed="showWorkout" class="buttons" variant="primary"
                    @click="toggleWorkout">Workouts</b-button>
            </div>

            <b-row>
                <b-col cols=5 class="client-search-div">
                    <div class="d-flex flex-row align-items-center">
                        <div class="ml-2 w-100 px-4 px-md-1">
                            <multiselect v-model="selectedUsers" id="ajax" label="name" track-by="id"
                                placeholder="Select users (Type at least 3 letters)" title="Select the clients"
                                :options="allUsersList" :multiple="true" :searchable="true" :loading="isLoading"
                                :clear-on-select="true" :close-on-select="false" :hide-selected="true" :allow-empty="true"
                                @search-change="asyncFind">

                                <template slot="clear" slot-scope="props">
                                    <div class="multiselect__clear" v-if="selectedUsers.length"
                                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                                </template><span slot="noResult">No users found</span>

                            </multiselect>
                        </div>
                    </div>
                </b-col>

                <b-col cols=1>
                    <b-button class="user-button" variant="primary" @click="userFilter">Search</b-button>
                </b-col>

                <b-col cols=2 class="users-clear-col">
                    <b-button class="user-button" variant="secondary" @click="clearUserFilter">Clear</b-button>
                </b-col>

                <b-col v-if="showUser && !isEmptyUser" class="download-button-col">
                    <b-dropdown text="Download CSV" variant="info">
                        <b-dropdown-item-button @click="downloadCSV(false)">Download this page</b-dropdown-item-button>
                        <b-dropdown-item-button @click="downloadCSV(true)">Download all rows</b-dropdown-item-button>
                    </b-dropdown>
                </b-col>

                <b-col v-if="showWorkout && !isEmptyWorkout" class="download-button-col">
                    <b-dropdown text="Download CSV" variant="info">
                        <b-dropdown-item-button @click="downloadCSV(false)">Download this page</b-dropdown-item-button>
                        <b-dropdown-item-button @click="downloadCSV(true)">Download all rows</b-dropdown-item-button>
                    </b-dropdown>
                </b-col>
            </b-row>

            <div v-if="showUser && !showWorkout" class="border-0">
                <div class="card-body px-0 rounded overflow-auto">
                    <div class="b2b-table">
                        <b-table id="userTable" striped hover :items="rowsUser" :fields="fieldsUser" :busy="isLoading"
                            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @row-clicked="redirectUser">

                        </b-table>

                    </div>
                    <div v-if="isEmptyUser">
                        <p class="no-data"> No Data Available</p>
                    </div>

                    <div class="pagination">
                        <Multiselect :options="pageSizeArray" v-model="pageSizeUser" class="pageSizeMS" />
                        <b-pagination v-model="pageUser" :total-rows="totalRecordsUser" :per-page="pageSizeUser" />
                    </div>
                </div>
            </div>

            <div v-if="!showUser && showWorkout" class="border-0">
                <div class="mx-1 mt-4 w-100">
                    <div class="overflow-auto w-100 d-none d-md-block b2b-table">
                        <b-table id="workoutTable" small responsive :items="rowsWorkout" :fields="fields"
                            thead-tr-class="row-class row-class-header">

                            <template #cell(show_details)="row">

                                <b-button size="sm" class="mb-2 arrow-down" @click="row.toggleDetails">
                                    <b-icon :icon=myIcon @click="clickHandler()"></b-icon>
                                </b-button>
                            </template>

                            <template #row-details="row">
                                <div class="dropdown-div">
                                    <b-row>
                                        <b-col class="dropdown-top-col">
                                            <b>Video Duration</b>
                                            <br>
                                            {{ row.item.video_duration }}
                                        </b-col>
                                        <b-col class="dropdown-top-col">
                                            <b>Session ID</b>
                                            <br>
                                            {{ row.item.session_id }}
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col class="dropdown-bottom-col">
                                            <b>Workout Duration</b>
                                            <br>
                                            {{ row.item.workout_duration }}
                                        </b-col>
                                        <b-col class="dropdown-bottom-col">
                                            <b>Youtube ID</b>
                                            <br>
                                            {{ row.item.youtube_id }}
                                        </b-col>
                                    </b-row>

                                    <b-row>

                                        <b-col class="dropdown-bottom-col">
                                            <b>Percentage of Completion</b>
                                            <br>
                                            {{ row.item.workout_completed_percentage }}
                                        </b-col>
                                    </b-row>
                                </div>
                            </template>

                        </b-table>
                    </div>

                    <div v-if="isEmptyWorkout">
                        <p class="no-data"> No Data Available</p>
                    </div>

                    <div class="pagination">
                        <Multiselect :options="pageSizeArray" v-model="pageSizeWorkout" class="pageSizeMS" />
                        <b-pagination v-model="pageWorkout" :total-rows="totalRecordsWorkout" :per-page="pageSizeWorkout" />
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
import API from "../api.js"
import Multiselect from 'vue-multiselect';
import router from "@/router";

export default {
    name: "ReportingDashboard",

    data() {
        return {
            minFromDate: undefined,
            maxFromDate: undefined,
            minToDate: undefined,
            maxToDate: undefined,
            fromDate: '',
            toDate: '',
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            isLoading: false,
            showUser: true,
            showWorkout: false,
            sortBy: '',
            sortDesc: false,
            rowsUser: [],
            fieldsUser: [
                { key: 'sign_up_date', sortable: true },
                { key: 'user_id', sortable: true },
                { key: 'email', sortable: true },
                { key: 'workouts_clicked', sortable: true },
                { key: 'workouts_completed', sortable: true },
                { key: 'workout_duration', sortable: true }
            ],
            rowsWorkout: [],
            clientRows: [],
            pageSizeUser: 20,
            pageUser: 1,
            pageSizeWorkout: 20,
            pageWorkout: 1,
            pageSizeArray: [10, 20, 50, 100],
            minWorkoutDuration: 0,
            minWorkouts: 1,
            percentageOfWorkout: 80,
            totalRecordsUser: 0,
            totalRecordsWorkout: 0,
            tenantId: this.$route.params.id,
            selectedUsers: [],
            selectedUsersID: [],
            allUsersList: [],
            totalUsers: 0,
            newUsers: 0,
            activeUsers: 0,
            workoutsClicked: 0,
            workoutsDuration: 0,
            clientName: '',
            isEmptyUser: true,
            isEmptyWorkout: true,
            myIcon: "arrow-right",
            isClicked: false,
            reportsConfig: {
                weeklyReport: {
                    label: "Weekly Report",
                    link: `/admin/reporting/weeklyChallenge/`
                }
            }
        }
    },

    methods: {

        redirectUser(item) {
            if (item && item.user_id) {
                this.$router.push(`/admin/reporting/client/user/${item.user_id}`);
            }
        },

        toggleUser() {
            this.showUser = true;
            this.showWorkout = false;
        },
        toggleWorkout() {
            this.showUser = false;
            this.showWorkout = true;
        },

        dateFilter() {
            this.corporateUsers()
            this.corporateWorkouts()
            this.corporateUserSummary()
        },

        async clearDateFilter() {
            this.fromDate = '';
            this.toDate = '';
        },

        criteriaFilter() {
            this.corporateUserSummary();
            this.corporateUsers();
            this.$refs['criteria-modal'].hide()
        },

        clearCriteriaFilter() {
            this.minWorkoutDuration = 0;
            this.minWorkouts = 1;
            this.percentageOfWorkout = 80;
        },

        userFilter() {
            this.selectedUsersID = this.selectedUsers.map((client) => client.id).toString()
            this.corporateUsers();
            this.corporateWorkouts();
        },

        clearUserFilter() {
            this.selectedUsers = [];
            this.selectedUsersID = [];
            this.corporateUsers();
            this.corporateWorkouts();
        },

        clickHandler() {
            this.isClicked = !this.isClicked
            this.myIcon = this.isClicked ? "arrow-down" : "arrow-right"
        },

        formatDate(isoDateString) {
            const date = new Date(isoDateString);
            const formattedDateString = date.toLocaleString("en-US", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
            });
            return formattedDateString;
        },

        secondsToMinutes(total) {
            let minutes = 0;
            let hours = 0;
            let seconds = 0;
            minutes = Math.trunc(total / 60);
            seconds = Math.trunc(total % 60);
            hours = Math.trunc(minutes / 60);
            minutes = Math.trunc(minutes % 60);

            if (hours > 0)
                return hours + "h " + minutes + "m " + seconds + "s "

            else if (minutes > 0)
                return minutes + "m " + seconds + "s "

            else
                return seconds + "s"
        },

        workoutDurationFormat(total) {
            let minutes = 0;
            let hours = 0;
            let seconds = 0;
            minutes = Math.trunc(total / 60);
            seconds = total % 60;
            hours = Math.trunc(minutes / 60);
            minutes = Math.trunc(minutes % 60);

            if (hours > 0)
                return hours + "h " + minutes + "m "

            else if (minutes > 0)
                return minutes + "m "

            else if (minutes <= 0)
                return seconds + "s "
        },

        getQueryParams() {
            const queryParams = new URLSearchParams(window.location.search)
            this.fromDate = queryParams.get('startDate')
            this.toDate = queryParams.get('endDate')
        },

        async asyncFind(userName) {
            const params = {
                tenantId: this.tenantId,
                name: userName
            }
            try {
                if (userName.length >= 3) {
                    let res = await API.corporateUserSearch(params)
                    res.data.forEach((user) => {
                        this.allUsersList.push({
                            id: user.user_id,
                            name: user.name + ' (' + user.email + ')'
                        })
                    })
                }
            }
            catch (error) {
                console.log("There is an error in the search query", error);
            }
        },

        clearAll() {
            this.selectedUsers = []
        },

        async downloadCSV(downloadAll = false) {
            const downloadCSVParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                perPage: downloadAll ? this.showUser ? this.totalRecordsUser : this.totalRecordsWorkout : this.showUser ? this.pageSizeUser : this.pageSizeWorkout,
                page: this.pageWorkout,
                resType: 'CSV',
            }

            if (this.showUser) {
                try {
                    let data = await API.corporateUsers(downloadCSVParam)

                    const blob = new Blob([data], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.setAttribute('href', url)
                    a.setAttribute('download', 'CorporateUsers.csv');
                    a.click()
                }
                catch (error) {
                    console.log("There is an error in Downloading CSV", error);
                }
            }

            else if (this.showWorkout) {
                try {
                    let data = await API.corporateWorkouts(downloadCSVParam)

                    const blob = new Blob([data], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.setAttribute('href', url)
                    a.setAttribute('download', 'CorporateWorkouts.csv');
                    a.click()
                }
                catch (error) {
                    console.log("There is an error in Downloading CSV", error);
                }
            }

        },

        async corporateUserSummary() {
            const corporateUserSummaryParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                minWorkouts: this.minWorkouts,
                minWorkoutDuration: this.minWorkoutDuration
            }
            try {
                let res = await API.corporateUserSummary(corporateUserSummaryParam)
                this.activeUsers = res.data.activeUsers.length
                this.newUsers = res.data.newUsers
                this.workoutsClicked = res.data.workoutClicked
                this.workoutsDuration = this.workoutDurationFormat(res.data.workoutDurationSec)
                this.clientRows = [{
                    client_logo: res.data.userDetails[0].logo,
                    client_name: res.data.userDetails[0].name,
                    total_users: res.data.userCount,
                    created_on: this.formatDate(res.data.userDetails[0].created_at),
                    reports: res.data.userDetails[0].config == null ? '' : res.data.userDetails[0].config.reports
                }]
                this.clientName = res.data.userDetails[0].name

            }
            catch (error) {
                console.log("There is an error in corporateUserSummary", error);
            }
        },

        async corporateUsers() {
            const corporateUsersParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                perPage: this.pageSizeUser,
                page: this.pageUser,
                selectedUsers: this.selectedUsersID,
                sortBy: this.sortBy,
                sortDirection: this.sortDesc ? 'DESC' : 'ASC',
                percentageOfWorkout: this.percentageOfWorkout
            }
            try {
                let res = await API.corporateUsers(corporateUsersParam)
                this.rowsUser = [];
                res.data.rows.forEach((item) => {
                    this.rowsUser.push({
                        sign_up_date: this.formatDate(item.signUpDate),
                        user_id: item.userId,
                        email: item.userEmail,
                        workouts_clicked: parseInt(item.workoutsClicked).toLocaleString('en-US'),
                        workouts_completed: parseInt(item.workoutsCompleted).toLocaleString('en-US'),
                        workout_duration: this.workoutDurationFormat(item.workoutsDurationSec)
                    });
                    this.isEmptyUser = false;
                });
                this.totalRecordsUser = res.data.total
            }
            catch (error) {
                console.log("There is an error in corporateUsers", error);
            }
        },

        async corporateWorkouts() {
            const corporateWorkoutsParam = {
                tenantId: this.tenantId,
                startDate: this.fromDate,
                endDate: this.toDate,
                perPage: this.pageSizeWorkout,
                page: this.pageWorkout,
                selectedUsers: this.selectedUsersID
            }
            try {
                let res = await API.corporateWorkouts(corporateWorkoutsParam)
                this.rowsWorkout = []
                res.data.rows.forEach((item) => {
                    this.rowsWorkout.push({
                        workout_date_and_time: this.formatDate(item.workoutDate),
                        email: item.userEmail,
                        video_id: item.videoId,
                        video_title: item.videoTitle,
                        video_duration: this.secondsToMinutes(item.videoDurationSec),
                        session_id: item.sessionId,
                        workout_duration: item.workoutDurationSec + " seconds",
                        accuracy_score: item.accuracyScore + "%",
                        calories_burnt: item.caloriesBurnt,
                        workout_completed_percentage: item.workoutCompletedPercentage + "%",
                        youtube_id: item.youtubeEmbedId
                    });
                    this.isEmptyWorkout = false;
                });

                this.totalRecordsWorkout = res.data.total
            }
            catch (error) {
                console.log("There is an error in corporateWorkouts", error);
            }
        },
    },

    computed: {
        fields() {
            return [
                { key: 'show_details', label: '' },
                { key: 'workout_date_and_time', label: 'Date/Time' },
                { key: 'email', label: 'User\'s Email' },
                { key: 'video_title', label: 'Video Title' },
                { key: 'video_id', label: 'Video ID' },
                { key: 'accuracy_score', label: 'Accuracy Score' },
                { key: 'calories_burnt', label: 'Calories Burnt' },
            ];
        },
    },

    watch: {
        fromDate: function (val) {
            ''
            this.minToDate = new Date(val);
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val);
        },
        pageUser() {
            this.corporateUsers();
        },
        pageSizeUser() {
            if (this.pageSizeUser !== 0) {
                this.corporateUsers();
            }
        },

        pageWorkout() {
            this.corporateWorkouts();
        },
        pageSizeWorkout() {
            if (this.pageSizeWorkout !== 0) {
                this.corporateWorkouts();
            }
        },
        sortBy() {
            this.corporateUsers();
        },
        sortDesc() {
            this.corporateUsers();
        },
    },

    components: {
        Multiselect
    },

    mounted() {
        this.getQueryParams();
        this.corporateUsers();
        this.corporateWorkouts();
        this.corporateUserSummary();
    },
}
</script>

<style lang="scss" scoped>
// Multiselect
::v-deep .multiselect__tags {
    min-height: 0;
    padding: 0;
    background: #FFFFFF !important;
    border: 2px solid #73BC44;
    border-radius: 5px !important;
    height: 34px !important;
    min-width: 135px !important;
    display: flex;
    align-items: center;
}

::v-deep .multiselect__placeholder {
    margin: 5px 0 5px 10px;
    color: #969B92;
    font-weight: 500;
}

::v-deep .multiselect__single {
    margin-bottom: 0px !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #141513 !important;
}

::v-deep .multiselect__select:before {
    color: #73BC44 !important;
    border-color: #73BC44 transparent transparent;
}

::v-deep .multiselect__tags-wrap {
    display: flex !important;
    align-items: center !important;
}

::v-deep .multiselect__tag {
    margin-bottom: 0;
}

// No Data Message
.no-data {
    color: white;
    margin-left: 15px;
}

// Criteria for Active Users
h5 {
    color: white;
    padding-left: 15px;
    padding-top: 10px;
}

hr {
    height: 3px;
    background-color: #ccc;
    border: none;
}

.criteria-label {
    color: white;
    padding-left: 10px;
}

.criteria-button {
    margin-top: 0px;
    padding-left: 10px;
}

.criteria-label-col {
    padding-left: 20px;
}

.criteria-div {
    padding-top: 30px;
}

.criteria-div-apply {
    padding-left: 20px;
    padding-bottom: 30px;
    padding-top: 30px;
}

.criteria-div-clear {
    padding-left: 15px;
    padding-bottom: 30px;
    padding-top: 30px;
}

.min-workout-search-bar {
    padding: 0px;
}

.percentage-workout-search-bar {
    padding: 0px;
    margin-bottom: 20px;
}

// Settings Icon
.card-div {
    margin-top: 20px;
}

.settings-icon-img {
    display: block;
    margin-left: auto;
    padding-bottom: 40px;
}

// Card Body
.card {
    border: none;
    background-color: #323232;
    margin-top: 30px;
    margin-bottom: 30px;

    .card-body {
        position: relative;
        padding-bottom: 30px;

        .info-card-title {
            color: #41c300;
            font-weight: bold;
        }

        .value {
            font-size: xx-large;
        }

        .message {
            font-size: small;
            position: absolute;
            bottom: 15px;
            width: 85%;
        }

        .table {
            cursor: pointer;
        }
    }
}

.border-card {
    border: 2px solid #969B92 !important;
    background-color: #F4F6F9;
    box-shadow: none;
    color: #141513;

    .card-body {
        .info-card-title {
            color: #969B92;
            font-weight: bold;
            font-size: 12px;
            line-height: 18px;
        }

        .value {
            font-weight: bold;
            font-size: 16px !important;
            line-height: 24px;
        }
    }
}

.i-border {
    border: 1px solid #73BC44;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    text-align: center;
    justify-content: center;
    display: inline-block;
    font-size: 11px;
    color: #fff;
    margin-left: 2px;
    transform: translateY(-2px);
}

// Breadcrumbs
.breadCrumb {
    background-color: #323232;
}

// Client Details Card
.tableContainer {
    padding: 10px;
    margin: 10px;
    margin-bottom: 10px;
}

.client-logo {
    height: 50px;
    width: 50px
}

/* Date Picker and Buttons */

.filter-label {
    top: 50%;
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    color: white;
}

.date-picker-div {
    padding-left: 0px;
    padding-right: 10px;
}

.date-div {
    padding-left: 10px;
}

.date-button {
    margin-top: 15px;
    height: 35px;
}

.clear-button {
    margin-top: 15px;
    height: 35px;
}

// Button Tabs
.buttons {
    margin-right: 10px;
    margin-bottom: 30px;
}

.buttons-container {
    margin-top: 30px;
}

// Client Search Bar

.client-search-div {
    padding-left: 0px;
    padding-right: 10px;
}

.user-button {
    height: 35px;
}

.users-clear-col {
    margin-left: 15px;
}

// Download Button
.download-button-col {
    text-align: right;
}

//Drop Down Arrow
.arrow-down {
    margin-top: 30%;
}

.dropdown-div {
    background-color: #515a5c;
    border-radius: 50;
    margin-top: 10px;
    margin-bottom: 10px;
}

.dropdown-top-col {
    margin-left: 50px;
    margin-top: 30px;
}

.dropdown-bottom-col {
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 30px;
}

// Pagination
.pageSizeMS {
    width: 200px;
    margin-left: 10px;
    margin-right: 25px;
}
</style>
